module.exports = __webpack_public_path__ + "static/media/0046.d0ef90d3.svg";